class SizeChart extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector(".custom-size--content");
    this.heading = this.querySelector(".custom-size--wrapper");
    this.headerGroup = document.querySelector(".shopify-section-header-sticky");
    this.closeButton = this.querySelector(".close");
    this.body = document.querySelector("body");

    this.heading.addEventListener("click", () => {
      this.toggleModal();
    });

    this.closeButton.addEventListener("click", () => {
      this.hideModal();
    });
  }

  toggleModal() {
    if (!this.content.classList.contains("active")) {
      this.content.classList.add("active");
      this.body.classList.add("overflow-hidden");
      this.headerGroup.classList.add("header-index");
    } else {
      this.hideModal();
    }
  }

  hideModal() {
    this.content.classList.remove("active");
    this.body.classList.remove("overflow-hidden");
    this.headerGroup.classList.remove("header-index");
  }
}

customElements.define("size-chart", SizeChart);
